'use strict';
import classNames from 'classnames';
import isObject from 'lodash/isObject';
import * as T from 'prop-types';
import React from 'react';
import {CommentIndicator} from '../../../comments/components/CommentIndicator';
import {ListItem} from '../../../components/lists/ListItem';
import {StatelessStatusSelector} from '../../../core-components/selectors/components/StatelessStatusSelector';
import {getCollection, getId} from '../../../core-utilities/domain/ReduxUtils';
import {getMessagesFromProps} from '../../../core-utilities/react-i18n';
import {getItemTitle, stopPropagation} from '../../../core-utilities/react-utils';
import {PinButton} from '../../../priorities/components/PinButton';
import {getScheduleStatus} from '../../domain/utils';
import {ScheduleModalMode} from '../../enums/ScheduleModalMode';
import {TaskAssignment} from '../TaskAssignment';
import {TaskProgress} from '../TaskProgress';


export function TaskItemView(props) {
  return (
    <ListItem
      className={classNames(props.className, {
        "TaskCard_cardMode": props.isCardMode,
        "TaskCard_itemMode": !props.isCardMode,
      })}
      bindParam={props.model}
      onClick={props.onClick}
      onContextMenu={props.onContextMenu}
    >
      {taskItemViewCard(props)}
      {taskItemViewItem(props)}
    </ListItem>
  );
}

function taskItemViewCard(props) {
  const model = props.model;
  const description = model.description;
  const itemTitle = getItemTitle(model);
  const fileCountLabel = getFileRequirementMetrics(model.metrics);

  return (
    <div className="TaskCard">
      <div className={'card ' + getScheduleStatus(model)}>
        <div className="TaskCard__body">
          <div
            className="TaskCard__statusSelector"
            onClick={stopPropagation}
          >
            <StatelessStatusSelector
              model={model}
              status={model.status}
              validStatuses={model.validStatuses}
              hideValue={true}
            />
          </div>

          <div
            className="TaskCard__nameArea"
            title={itemTitle}
          >
            <span>
              {model.name}
            </span>
            <div className="task-card-description">
              <span>
                {description}
              </span>
            </div>
          </div>

          <TaskProgress
            className="TaskCard__progressContainer"
            status={model.status}
            {...getMessagesFromProps(props, TaskProgress.messageProps)}
          />

          <i className="TaskCard__navIcon icon ion-chevron-right" />
        </div>

        <TaskAssignment
          className="TaskCard__assignment"
          scheduleModalMode={ScheduleModalMode.local}
          model={model}

          init={props.init}
          {...getMessagesFromProps(props, TaskAssignment.messageProps)}
        />

        <div className="TaskCard__stats">
          <div className="TaskCard__metrics">
            <div className="TaskCard__metrics__container">
              <i className="icon ion-ios-folder-outline" />
              <span className="TaskCard__metrics__label">
                {fileCountLabel}
              </span>
            </div>

          </div>
          <div
            className="TaskCard__buttons"
            onClick={stopPropagation}
          >
            <div className="TaskCard__buttons_comment">
              <CommentIndicator
                userId={props.userId}
                chatId={getId(model)}
                collection={getCollection(model)}
                allowNav={true}

                init={props.init}
                {...getMessagesFromProps(props, CommentIndicator.messageProps)}
              />
            </div>
            <PinButton
              className="TaskCard__buttons_pin"
              onClick={props.onTogglePin}
              isPinned={model.isPinned}
              isPinning={props.isPinning}
              {...getMessagesFromProps(props, PinButton.messageProps)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function taskItemViewItem(props) {
  const model = props.model;
  const description = model.description;
  const itemTitle = getItemTitle(model);

  return (
    <div
      className={classNames(
        'TaskItem item item-icon-left item-icon-right',
        getScheduleStatus(model),
        {
          'double-line': !!description,
        })}
    >
      <div
        className="TaskItem__left icon"
        onClick={stopPropagation}
      >
        <StatelessStatusSelector
          model={model}
          status={model.status}
          validStatuses={model.validStatuses}
          hideValue={true}
        />
      </div>

      <div
        className="TaskItem__content item-content"
        title={itemTitle}
      >
        <h2 className={classNames({
          TaskItem__title_single: !description,
        })}
        >
          {model.name}
        </h2>
        <div
          className="item-description"
        >
          {description}
        </div>
      </div>

      <div
        className="TaskItem__right icon"
        onClick={stopPropagation}
      >
        <CommentIndicator
          userId={props.userId}
          chatId={getId(model)}
          collection={getCollection(model)}
          allowNav={true}

          init={props.init}
          {...getMessagesFromProps(props, CommentIndicator.messageProps)}
        />
      </div>
    </div>
  );
}

TaskItemView.propTypes = {
  className: T.string,
  isCardMode: T.bool,
  model: T.object.isRequired,
  isPinning: T.bool,

  onClick: T.func.isRequired,
  onContextMenu: T.func.isRequired,
  onTogglePin: T.func.isRequired,

  init: T.bool,
};

TaskItemView.defaultProps = {
  init: true,
};

TaskItemView.messages = [
  ...CommentIndicator.messages,
  ...PinButton.messages,
  ...TaskAssignment.messages,
  ...TaskProgress.messages,
];

TaskItemView.messageProps = [
  ...CommentIndicator.messageProps,
  ...PinButton.messageProps,
  ...TaskAssignment.messageProps,
  ...TaskProgress.messageProps,
];

export function getFileRequirementMetrics(metrics) {
  if (!isObject(metrics)) {
    return '-';
  } else {
    const total = metrics.reqCount - metrics.reqCancelled;
    const current = metrics.reqSubmitted + metrics.reqApproved;

    return !total ? '-' : `${current}/${total}`;
  }
}



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskItem/TaskItemView.js